import { render, staticRenderFns } from "./MiningForm.vue?vue&type=template&id=7bdaf880&scoped=true&"
import script from "./MiningForm.vue?vue&type=script&lang=js&"
export * from "./MiningForm.vue?vue&type=script&lang=js&"
import style0 from "./MiningForm.vue?vue&type=style&index=0&id=7bdaf880&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdaf880",
  null
  
)

export default component.exports